<template>
  <jade-box v-if="itemsLength">
    <JadeGroupHeader>
      {{ $t('title') }}
      <template #trailing>
        <div
          v-if="loading"
          class="mt-1"
        >
          <JadeSpinner
            v-if="loading"
            size="large"
          />
        </div>
        <JadeBadge
          v-else
          voice="warning"
        >
          {{ itemsLength }}+
        </JadeBadge>
      </template>
    </JadeGroupHeader>
    <template v-if="!loading">
      <div
        v-for="(item, index) in items"
        :key="`list-item-due-${index}`"
      >
        <router-link
          :key="index"
          :to="toLink(item.transactionId)"
        >
          <jade-list-item
            navigation
            :label="item.chargeback.reasonDescription"
            :description="item.transactionalData.amount"
            :thirdLine="
              $t('expires-at', { days: getExpirationDays(item.createdAt) })
            "
            @onClick="'javascript:void(0)'"
          >
            <template slot="leading">
              <jade-icon use="circle-alert" />
            </template>
            <template slot="trailing">
              <div class="flex flex-col">
                <jade-text>
                  {{ item.transactionalData.amount }}
                </jade-text>
                <div class="mt-1">
                  <jade-tag
                    size="medium"
                    :variant="statusBadge(item.status.code)"
                  >
                    {{ item.status.label }}
                  </jade-tag>
                </div>
              </div>
            </template>
          </jade-list-item>
        </router-link>
      </div>
    </template>
    <div
      class="mt-2"
      v-if="!loading"
    >
      <jade-divider />
    </div>
    <div class="p-5 flex justify-end">
      <jade-pagination
        @onPrevious="requestPrevious"
        @onNext="requestNext"
        :disabledPrevious="!hasPaginationPrevious || loading"
        :disabledNext="!hasPaginationNext || loading"
      />
    </div>
  </jade-box>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  JadeListItem,
  JadeGroupHeader,
  JadeText,
  JadeTag,
  JadeBadge,
  JadeIcon,
  JadeBox,
  JadeDivider,
  JadeSpinner,
  JadePagination
} from '@jade'

import ChargebackManager from '../chargeback.manager.js'
import ChargebackDetailsManager from '../Details/chargeback-details.manager.js'

export default {
  name: 'DueChargebacks',
  components: {
    JadeListItem,
    JadeGroupHeader,
    JadeTag,
    JadeBadge,
    JadeText,
    JadeIcon,
    JadeBox,
    JadeDivider,
    JadeSpinner,
    JadePagination
  },
  data () {
    return {
      page: 1,
      limit: 5
    }
  },
  computed: {
    ...mapGetters({
      chargebacks: 'dueChargebacks',
      loading: 'loadingDueChargebacks'
    }),
    items () {
      return this.chargebacks?.items
    },
    pagination () {
      return this.chargebacks?.pagination
    },
    itemsLength () {
      return this.items?.length
    },
    hasPaginationPrevious () {
      return this.pagination?.prev
    },
    hasPaginationNext () {
      return this.pagination?.next
    }
  },
  mounted () {
    this.getAllDueChargebacks({ page: this.page, limit: this.limit })
  },
  methods: {
    ...mapActions({ getAllDueChargebacks: 'GET_ALL_DUE_CHARGEBACKS' }),
    toLink (id) {
      return {
        name: 'chargebackDetails',
        params: {
          chargeback_id: id
        }
      }
    },
    statusBadge (code) {
      return ChargebackManager.chargebackStatusBadge(code)
    },
    isNotLast (index) {
      return index !== this.items.length - 1
    },
    getExpirationDays (createdAt) {
      return ChargebackDetailsManager.remainingDays(createdAt)
    },
    requestNext () {
      this.page = this.page + 1
      this.getAllDueChargebacks({ page: this.page, limit: this.limit })
    },
    requestPrevious () {
      this.page = this.page - 1
      this.getAllDueChargebacks({ page: this.page, limit: this.limit })
    }
  }
}
</script>

<i18n>
 {
  "pt-BR": {
    "title": "Contestações pendentes",
    "expires-at": "Expira em {days} dias"
  },
  "en-US": {
    "title": "Pending chargebacks",
    "expires-at": "Expires in {days} days"
  }
 }

</i18n>
